import {TheCageGameAssets} from "../TheCageGameAssets";
import {TheCage} from "../TheCage";
import {BetWayWin} from "../server/TheCageData";
import {gsap} from "gsap";

/**
 * Created by jonas on 2022-09-05.
 */

export class LineWinDisplay extends PIXI.Container{
    private winAmount:any;
    private ways:any;

    constructor(betWayWin:BetWayWin) {
        super();

        this.winAmount = new PIXI.BitmapText(TheCage.apiPlugin.currency.formatValue(betWayWin.amount), {
            fontName:TheCageGameAssets.BITMAP_FONT_WIN_COUNT_UP,
            fontSize:50,
            tint:0xffffff
        });


        const waysEnding = betWayWin.numberOfCombinations > 1 ? " z" : " y";
        this.ways = new PIXI.BitmapText(betWayWin.numberOfCombinations + waysEnding, {
            fontName:TheCageGameAssets.BITMAP_FONT_WAYS_WON,
            fontSize:30,
            tint:0xffffff
        });


        if (betWayWin.multiplier > 1) {
            this.winAmount.text += ` x ${betWayWin.multiplier}`;
        }

        this.winAmount.anchor = new PIXI.Point(0.5,1);
        this.winAmount.position.set(0,5);

        this.ways.anchor = new PIXI.Point(0.5,0);
        this.ways.position.set(0,5);

        this.ways.alpha = 0;


        this.addChild(this.winAmount, this.ways);
    }

    public getAnimation(durScale:number = 1) {
        const tl = gsap.timeline();
        const dur = durScale * 0.7;
        tl.add(gsap.to(this, {duration:durScale * 0.1, alpha:1}));

        tl.add(gsap.to(this.ways, {duration:durScale * 0.2, alpha:1}));
        tl.add(gsap.to(this.ways, {duration:durScale * 0.2, y:-5}), "<");


        tl.add(gsap.to(this, {duration:dur, y:this.y - 50}));
        tl.add(gsap.to(this, {duration:dur*0.5, alpha:0}),`<${dur*0.5}`);

        return tl;
    }
}